function Util() { }

Util.hasClass = function (el, className) {
	if (el.classList) return el.classList.contains(className);
	else
		return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};

Util.addClass = function (el, className) {
	var classList = className.split(' ');
	if (el.classList) el.classList.add(classList[0]);
	else if (!Util.hasClass(el, classList[0])) el.className += ' ' + classList[0];
	if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function (el, className) {
	var classList = className.split(' ');
	if (el.classList) el.classList.remove(classList[0]);
	else if (Util.hasClass(el, classList[0])) {
		var reg = new RegExp('(\\s|^)' + classList[0] + '(\\s|$)');
		el.className = el.className.replace(reg, ' ');
	}
	if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.toggleClass = function (el, className, bool) {
	if (bool) Util.addClass(el, className);
	else Util.removeClass(el, className);
};

Util.setAttributes = function (el, attrs) {
	for (var key in attrs) {
		el.setAttribute(key, attrs[key]);
	}
};

Util.getChildrenByClassName = function (el, className) {
	var children = el.children,
		childrenByClass = [];
	for (var i = 0; i < el.children.length; i++) {
		if (Util.hasClass(el.children[i], className))
			childrenByClass.push(el.children[i]);
	}
	return childrenByClass;
};

Util.is = function (elem, selector) {
	if (selector.nodeType) {
		return elem === selector;
	}

	var qa =
		typeof selector === 'string'
			? document.querySelectorAll(selector)
			: selector,
		length = qa.length,
		returnArr = [];

	while (length--) {
		if (qa[length] === elem) {
			return true;
		}
	}

	return false;
};

Util.setHeight = function (start, to, element, duration, cb) {
	var change = to - start,
		currentTime = null;

	var animateHeight = function (timestamp) {
		if (!currentTime) currentTime = timestamp;
		var progress = timestamp - currentTime;
		var val = parseInt((progress / duration) * change + start);
		element.style.height = val + 'px';
		if (progress < duration) {
			window.requestAnimationFrame(animateHeight);
		} else {
			cb();
		}
	};

	element.style.height = start + 'px';
	window.requestAnimationFrame(animateHeight);
};

Util.scrollTo = function (final, duration, cb, scrollEl) {
	var element = scrollEl || window;
	var start = element.scrollTop || document.documentElement.scrollTop,
		currentTime = null;

	if (!scrollEl) start = window.scrollY || document.documentElement.scrollTop;

	var animateScroll = function (timestamp) {
		if (!currentTime) currentTime = timestamp;
		var progress = timestamp - currentTime;
		if (progress > duration) progress = duration;
		var val = Math.easeInOutQuad(progress, start, final - start, duration);
		element.scrollTo(0, val);
		if (progress < duration) {
			window.requestAnimationFrame(animateScroll);
		} else {
			cb && cb();
		}
	};

	window.requestAnimationFrame(animateScroll);
};

Util.moveFocus = function (element) {
	if (!element) element = document.getElementsByTagName('body')[0];
	element.focus();
	if (document.activeElement !== element) {
		element.setAttribute('tabindex', '-1');
		element.focus();
	}
};

Util.getIndexInArray = function (array, el) {
	return Array.prototype.indexOf.call(array, el);
};

Util.cssSupports = function (property, value) {
	if ('CSS' in window) {
		return CSS.supports(property, value);
	} else {
		var jsProperty = property.replace(/-([a-z])/g, function (g) {
			return g[1].toUpperCase();
		});
		return jsProperty in document.body.style;
	}
};

Util.extend = function () {
	var extended = {};
	var deep = false;
	var i = 0;
	var length = arguments.length;

	if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
		deep = arguments[0];
		i++;
	}

	var merge = function (obj) {
		for (var prop in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, prop)) {
				if (
					deep &&
					Object.prototype.toString.call(obj[prop]) === '[object Object]'
				) {
					extended[prop] = extend(true, extended[prop], obj[prop]);
				} else {
					extended[prop] = obj[prop];
				}
			}
		}
	};

	for (; i < length; i++) {
		var obj = arguments[i];
		merge(obj);
	}

	return extended;
};

Util.osHasReducedMotion = function () {
	if (!window.matchMedia) return false;
	var matchMediaObj = window.matchMedia('(prefers-reduced-motion: reduce)');
	if (matchMediaObj) return matchMediaObj.matches;
	return false;
};


if (!Element.prototype.matches) {
	Element.prototype.matches =
		Element.prototype.msMatchesSelector ||
		Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

if (typeof window.CustomEvent !== 'function') {
	function CustomEvent(event, params) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(
			event,
			params.bubbles,
			params.cancelable,
			params.detail
		);
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
}

Math.easeInOutQuad = function (t, b, c, d) {
	t /= d / 2;
	if (t < 1) return (c / 2) * t * t + b;
	t--;
	return (-c / 2) * (t * (t - 2) - 1) + b;
};

Math.easeInQuart = function (t, b, c, d) {
	t /= d;
	return c * t * t * t * t + b;
};

Math.easeOutQuart = function (t, b, c, d) {
	t /= d;
	t--;
	return -c * (t * t * t * t - 1) + b;
};

Math.easeInOutQuart = function (t, b, c, d) {
	t /= d / 2;
	if (t < 1) return (c / 2) * t * t * t * t + b;
	t -= 2;
	return (-c / 2) * (t * t * t * t - 2) + b;
};

Math.easeOutElastic = function (t, b, c, d) {
	var s = 1.70158;
	var p = d * 0.7;
	var a = c;
	if (t == 0) return b;
	if ((t /= d) == 1) return b + c;
	if (!p) p = d * 0.3;
	if (a < Math.abs(c)) {
		a = c;
		var s = p / 4;
	} else var s = (p / (2 * Math.PI)) * Math.asin(c / a);
	return (
		a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
		c +
		b
	);
};

(function () {
	var focusTab = document.getElementsByClassName('js-tab-focus');
	function detectClick() {
		if (focusTab.length > 0) {
			resetFocusTabs(false);
			window.addEventListener('keydown', detectTab);
		}
		window.removeEventListener('mousedown', detectClick);
	}

	function detectTab(event) {
		if (event.keyCode !== 9) return;
		resetFocusTabs(true);
		window.removeEventListener('keydown', detectTab);
		window.addEventListener('mousedown', detectClick);
	}

	function resetFocusTabs(bool) {
		var outlineStyle = bool ? '' : 'none';
		for (var i = 0; i < focusTab.length; i++) {
			focusTab[i].style.setProperty('outline', outlineStyle);
		}
	}
	window.addEventListener('mousedown', detectClick);
})();

(function () {
	var MegaNav = function (element) {
		this.element = element;
		this.search = this.element.getElementsByClassName('js-mega-nav__search');
		this.searchActiveController = false;
		this.menu = this.element.getElementsByClassName('js-mega-nav__nav');
		this.menuItems = this.menu[0].getElementsByClassName('js-mega-nav__item');
		this.menuActiveController = false;
		this.itemExpClass = 'mega-nav__item--expanded';
		this.classIconBtn = 'mega-nav__icon-btn--state-b';
		this.classSearchVisible = 'mega-nav__search--is-visible';
		this.classNavVisible = 'mega-nav__nav--is-visible';
		this.classMobileLayout = 'mega-nav--mobile';
		this.classDesktopLayout = 'mega-nav--desktop';
		this.layout = 'mobile';
		// store dropdown elements (if present)
		this.dropdown = this.element.getElementsByClassName('js-dropdown');
		// expanded class - added to header when subnav is open
		this.expandedClass = 'mega-nav--expanded';
		// check if subnav should open on hover
		this.hover = this.element.getAttribute('data-hover') && this.element.getAttribute('data-hover') == 'on';
		initMegaNav(this);
	};

	function initMegaNav(megaNav) {
		setMegaNavLayout(megaNav); // switch between mobile/desktop layout
		initMenu(megaNav); // control main menu nav - mobile only
		initSubNav(megaNav); // toggle sub navigation visibility

		megaNav.element.addEventListener('update-menu-layout', function (event) {
			setMegaNavLayout(megaNav); // window resize - update layout
		});
	};

	function setMegaNavLayout(megaNav) {
		var layout = getComputedStyle(megaNav.element, ':before').getPropertyValue('content').replace(/\'|"/g, '');
		if (layout == megaNav.layout) return;
		megaNav.layout = layout;
		Util.toggleClass(megaNav.element, megaNav.classDesktopLayout, megaNav.layout == 'desktop');
		Util.toggleClass(megaNav.element, megaNav.classMobileLayout, megaNav.layout != 'desktop');
		if (megaNav.layout == 'desktop') {
			closeSubNav(megaNav, false);
			// if the mega navigation has dropdown elements -> make sure they are in the right position (viewport awareness)
			triggerDropdownPosition(megaNav);
		}
		closeSearch(megaNav, false);
		resetMegaNavOffset(megaNav); // reset header offset top value
		resetNavAppearance(megaNav); // reset nav expanded appearance
	};

	function resetMegaNavOffset(megaNav) {
		document.documentElement.style.setProperty('--mega-nav-offset-y', megaNav.element.getBoundingClientRect().top + 'px');
	};

	function closeNavigation(megaNav) { // triggered by Esc key press
		// close search
		closeSearch(megaNav);
		// close nav
		if (Util.hasClass(megaNav.menu[0], megaNav.classNavVisible)) {
			toggleMenu(megaNav, megaNav.menu[0], 'menuActiveController', megaNav.classNavVisible, megaNav.menuActiveController, true);
		}
		//close subnav
		closeSubNav(megaNav, false);
		resetNavAppearance(megaNav); // reset nav expanded appearance
	};

	function closeFocusNavigation(megaNav) { // triggered by Tab key pressed
		// close search when focus is lost
		if (Util.hasClass(megaNav.search[0], megaNav.classSearchVisible) && !document.activeElement.closest('.js-mega-nav__search')) {
			toggleMenu(megaNav, megaNav.search[0], 'searchActiveController', megaNav.classSearchVisible, megaNav.searchActiveController, true);
		}
		// close nav when focus is lost
		if (Util.hasClass(megaNav.menu[0], megaNav.classNavVisible) && !document.activeElement.closest('.js-mega-nav__nav')) {
			toggleMenu(megaNav, megaNav.menu[0], 'menuActiveController', megaNav.classNavVisible, megaNav.menuActiveController, true);
		}
		// close subnav when focus is lost
		for (var i = 0; i < megaNav.menuItems.length; i++) {
			if (!Util.hasClass(megaNav.menuItems[i], megaNav.itemExpClass)) continue;
			var parentItem = document.activeElement.closest('.js-mega-nav__item');
			if (parentItem && parentItem == megaNav.menuItems[i]) continue;
			closeSingleSubnav(megaNav, i);
		}
		resetNavAppearance(megaNav); // reset nav expanded appearance
	};

	function closeSearch(megaNav, bool) {
		if (megaNav.search.length < 1) return;
		if (Util.hasClass(megaNav.search[0], megaNav.classSearchVisible)) {
			toggleMenu(megaNav, megaNav.search[0], 'searchActiveController', megaNav.classSearchVisible, megaNav.searchActiveController, bool);
		}
	};

	function initSearch(megaNav) {
		if (megaNav.search.length == 0) return;
		// toggle search
		megaNav.searchToggles = document.querySelectorAll('[aria-controls="' + megaNav.search[0].getAttribute('id') + '"]');
		for (var i = 0; i < megaNav.searchToggles.length; i++) {
			(function (i) {
				megaNav.searchToggles[i].addEventListener('click', function (event) {
					// toggle search
					toggleMenu(megaNav, megaNav.search[0], 'searchActiveController', megaNav.classSearchVisible, megaNav.searchToggles[i], true);
					// close nav if it was open
					if (Util.hasClass(megaNav.menu[0], megaNav.classNavVisible)) {
						toggleMenu(megaNav, megaNav.menu[0], 'menuActiveController', megaNav.classNavVisible, megaNav.menuActiveController, false);
					}
					// close subnavigation if open
					closeSubNav(megaNav, false);
					resetNavAppearance(megaNav); // reset nav expanded appearance
				});
			})(i);
		}
	};

	function initMenu(megaNav) {
		if (megaNav.menu.length == 0) return;
		// toggle nav
		megaNav.menuToggles = document.querySelectorAll('[aria-controls="' + megaNav.menu[0].getAttribute('id') + '"]');
		for (var i = 0; i < megaNav.menuToggles.length; i++) {
			(function (i) {
				megaNav.menuToggles[i].addEventListener('click', function (event) {
					// toggle nav
					toggleMenu(megaNav, megaNav.menu[0], 'menuActiveController', megaNav.classNavVisible, megaNav.menuToggles[i], true);
					// close search if it was open
					if (Util.hasClass(megaNav.search[0], megaNav.classSearchVisible)) {
						toggleMenu(megaNav, megaNav.search[0], 'searchActiveController', megaNav.classSearchVisible, megaNav.searchActiveController, false);
					}
					resetNavAppearance(megaNav); // reset nav expanded appearance
				});
			})(i);
		}
	};

	function toggleMenu(megaNav, element, controller, visibleClass, toggle, moveFocus) {
		var menuIsVisible = Util.hasClass(element, visibleClass);
		Util.toggleClass(element, visibleClass, !menuIsVisible);
		Util.toggleClass(toggle, megaNav.classIconBtn, !menuIsVisible);
		menuIsVisible ? toggle.removeAttribute('aria-expanded') : toggle.setAttribute('aria-expanded', 'true');
		if (menuIsVisible) {
			if (toggle && moveFocus) toggle.focus();
			megaNav[controller] = false;
		} else {
			if (toggle) megaNav[controller] = toggle;
			getFirstFocusable(element).focus(); // move focus to first focusable element
		}
	};

	function getFirstFocusable(element) {
		var focusableEle = element.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary'),
			firstFocusable = false;
		for (var i = 0; i < focusableEle.length; i++) {
			if (focusableEle[i].offsetWidth || focusableEle[i].offsetHeight || focusableEle[i].getClientRects().length) {
				firstFocusable = focusableEle[i];
				break;
			}
		}
		return firstFocusable;
	};

	function initSubNav(megaNav) {
		// toggle subnavigation visibility
		megaNav.element.addEventListener('click', function (event) {
			if (megaNav.hover && megaNav.layout == 'desktop') return; // data-hover="on"
			toggleSubNav(megaNav, event);
		});

		if (megaNav.hover) { // data-hover="on" => use mouse events
			megaNav.element.addEventListener('mouseover', function (event) {
				if (megaNav.layout != 'desktop') return;
				toggleSubNav(megaNav, event)
			});

			megaNav.element.addEventListener('mouseout', function (event) {
				if (megaNav.layout != 'desktop') return;
				var mainItem = event.target.closest('.js-mega-nav__item');
				if (!mainItem) return;
				var triggerBtn = mainItem.getElementsByClassName('js-mega-nav__control');
				if (triggerBtn.length < 1) return;
				var itemExpanded = Util.hasClass(mainItem, megaNav.itemExpClass);
				if (!itemExpanded) return;
				var mainItemHover = event.relatedTarget;
				if (mainItemHover && mainItem.contains(mainItemHover)) return;

				Util.toggleClass(mainItem, megaNav.itemExpClass, !itemExpanded);
				itemExpanded ? triggerBtn[0].removeAttribute('aria-expanded') : triggerBtn[0].setAttribute('aria-expanded', 'true');
			});
		}
	};

	function toggleSubNav(megaNav, event) {
		var triggerBtn = event.target.closest('.js-mega-nav__control');
		if (!triggerBtn) return;
		var mainItem = triggerBtn.closest('.js-mega-nav__item');
		if (!mainItem) return;
		var itemExpanded = Util.hasClass(mainItem, megaNav.itemExpClass);
		if (megaNav.hover && itemExpanded && megaNav.layout == 'desktop') return;
		Util.toggleClass(mainItem, megaNav.itemExpClass, !itemExpanded);
		itemExpanded ? triggerBtn.removeAttribute('aria-expanded') : triggerBtn.setAttribute('aria-expanded', 'true');
		if (megaNav.layout == 'desktop' && !itemExpanded) closeSubNav(megaNav, mainItem);
		// close search if open
		closeSearch(megaNav, false);
		resetNavAppearance(megaNav); // reset nav expanded appearance
	};

	function closeSubNav(megaNav, selectedItem) {
		// close subnav when a new sub nav element is open
		if (megaNav.menuItems.length == 0) return;
		for (var i = 0; i < megaNav.menuItems.length; i++) {
			if (megaNav.menuItems[i] != selectedItem) closeSingleSubnav(megaNav, i);
		}
	};

	function closeSingleSubnav(megaNav, index) {
		Util.removeClass(megaNav.menuItems[index], megaNav.itemExpClass);
		var triggerBtn = megaNav.menuItems[index].getElementsByClassName('js-mega-nav__control');
		if (triggerBtn.length > 0) triggerBtn[0].removeAttribute('aria-expanded');
	};

	function triggerDropdownPosition(megaNav) {
		// emit custom event to properly place dropdown elements - viewport awarness
		if (megaNav.dropdown.length == 0) return;
		for (var i = 0; i < megaNav.dropdown.length; i++) {
			megaNav.dropdown[i].dispatchEvent(new CustomEvent('placeDropdown'));
		}
	};

	function resetNavAppearance(megaNav) {
		((megaNav.element.getElementsByClassName(megaNav.itemExpClass).length > 0 && megaNav.layout == 'desktop') || megaNav.element.getElementsByClassName(megaNav.classSearchVisible).length > 0 || (megaNav.element.getElementsByClassName(megaNav.classNavVisible).length > 0 && megaNav.layout == 'mobile'))
			? Util.addClass(megaNav.element, megaNav.expandedClass)
			: Util.removeClass(megaNav.element, megaNav.expandedClass);
	};

	//initialize the MegaNav objects
	var megaNav = document.getElementsByClassName('js-mega-nav');
	if (megaNav.length > 0) {
		var megaNavArray = [];
		for (var i = 0; i < megaNav.length; i++) {
			(function (i) { megaNavArray.push(new MegaNav(megaNav[i])); })(i);
		}

		// key events
		window.addEventListener('keyup', function (event) {
			if ((event.keyCode && event.keyCode == 27) || (event.key && event.key.toLowerCase() == 'escape')) { // listen for esc key events
				for (var i = 0; i < megaNavArray.length; i++) {
					(function (i) {
						closeNavigation(megaNavArray[i]);
					})(i);
				}
			}
			// listen for tab key
			if ((event.keyCode && event.keyCode == 9) || (event.key && event.key.toLowerCase() == 'tab')) { // close search or nav if it looses focus
				for (var i = 0; i < megaNavArray.length; i++) {
					(function (i) {
						closeFocusNavigation(megaNavArray[i]);
					})(i);
				}
			}
		});

		window.addEventListener('click', function (event) {
			if (!event.target.closest('.js-mega-nav')) closeNavigation(megaNavArray[0]);
		});

		// resize - update menu layout
		var resizingId = false,
			customEvent = new CustomEvent('update-menu-layout');
		window.addEventListener('resize', function (event) {
			clearTimeout(resizingId);
			resizingId = setTimeout(doneResizing, 200);
		});

		function doneResizing() {
			for (var i = 0; i < megaNavArray.length; i++) {
				(function (i) { megaNavArray[i].element.dispatchEvent(customEvent) })(i);
			};
		};

		(window.requestAnimationFrame) // init mega site nav layout
			? window.requestAnimationFrame(doneResizing)
			: doneResizing();
	}
}());

(function () {
	var hidingNav = document.getElementsByClassName('js-hide-nav');
	if (hidingNav.length > 0 && window.requestAnimationFrame) {
		var mainNav = Array.prototype.filter.call(hidingNav, function (element) {
			return Util.hasClass(element, 'js-hide-nav--main');
		}),
			subNav = Array.prototype.filter.call(hidingNav, function (element) {
				return Util.hasClass(element, 'js-hide-nav--sub');
			});

		var scrolling = false,
			previousTop = window.scrollY,
			currentTop = window.scrollY,
			scrollDelta = 10,
			scrollOffset = 150, // scrollY needs to be bigger than scrollOffset to hide navigation
			headerHeight = 0;

		var navIsFixed = false; // check if main navigation is fixed
		if (mainNav.length > 0 && Util.hasClass(mainNav[0], 'hide-nav--fixed')) navIsFixed = true;

		// store button that triggers navigation on mobile
		var triggerMobile = getTriggerMobileMenu();
		var prevElement = createPrevElement();
		var mainNavTop = 0;
		// list of classes the hide-nav has when it is expanded -> do not hide if it has those classes
		var navOpenClasses = hidingNav[0].getAttribute('data-nav-target-class'),
			navOpenArrayClasses = [];
		if (navOpenClasses) navOpenArrayClasses = navOpenClasses.split(' ');
		getMainNavTop();
		if (mainNavTop > 0) {
			scrollOffset = scrollOffset + mainNavTop;
		}

		// init navigation and listen to window scroll event
		getHeaderHeight();
		initSecondaryNav();
		initFixedNav();
		resetHideNav();
		window.addEventListener('scroll', function (event) {
			if (scrolling) return;
			scrolling = true;
			window.requestAnimationFrame(resetHideNav);
		});

		window.addEventListener('resize', function (event) {
			if (scrolling) return;
			scrolling = true;
			window.requestAnimationFrame(function () {
				if (headerHeight > 0) {
					getMainNavTop();
					getHeaderHeight();
					initSecondaryNav();
					initFixedNav();
				}
				// reset both navigation
				hideNavScrollUp();

				scrolling = false;
			});
		});

		function getHeaderHeight() {
			headerHeight = mainNav[0].offsetHeight;
		};

		function initSecondaryNav() { // if there's a secondary nav, set its top equal to the header height
			if (subNav.length < 1 || mainNav.length < 1) return;
			subNav[0].style.top = (headerHeight - 1) + 'px';
		};

		function initFixedNav() {
			if (!navIsFixed || mainNav.length < 1) return;
			mainNav[0].style.marginBottom = '-' + headerHeight + 'px';
		};

		function resetHideNav() { // check if navs need to be hidden/revealed
			currentTop = window.scrollY;
			if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
				hideNavScrollDown();
			} else if (previousTop - currentTop > scrollDelta || (previousTop - currentTop > 0 && currentTop < scrollOffset)) {
				hideNavScrollUp();
			} else if (previousTop - currentTop > 0 && subNav.length > 0 && subNav[0].getBoundingClientRect().top > 0) {
				setTranslate(subNav[0], '0%');
			}
			// if primary nav is fixed -> toggle bg class
			if (navIsFixed) {
				var scrollTop = window.scrollY || window.pageYOffset;
				Util.toggleClass(mainNav[0], 'hide-nav--has-bg', (scrollTop > headerHeight + mainNavTop));
			}
			previousTop = currentTop;
			scrolling = false;
		};

		function hideNavScrollDown() {
			// if there's a secondary nav -> it has to reach the top before hiding nav
			if (subNav.length > 0 && subNav[0].getBoundingClientRect().top > headerHeight) return;
			// on mobile -> hide navigation only if dropdown is not open
			if (triggerMobile && triggerMobile.getAttribute('aria-expanded') == "true") return;
			// check if main nav has one of the following classes
			if (mainNav.length > 0 && (!navOpenClasses || !checkNavExpanded())) {
				setTranslate(mainNav[0], '-100%');
				mainNav[0].addEventListener('transitionend', addOffCanvasClass);
			}
			if (subNav.length > 0) setTranslate(subNav[0], '-' + headerHeight + 'px');
		};

		function hideNavScrollUp() {
			if (mainNav.length > 0) { setTranslate(mainNav[0], '0%'); Util.removeClass(mainNav[0], 'hide-nav--off-canvas'); mainNav[0].removeEventListener('transitionend', addOffCanvasClass); }
			if (subNav.length > 0) setTranslate(subNav[0], '0%');
		};

		function addOffCanvasClass() {
			mainNav[0].removeEventListener('transitionend', addOffCanvasClass);
			Util.addClass(mainNav[0], 'hide-nav--off-canvas');
		};

		function setTranslate(element, val) {
			element.style.transform = 'translateY(' + val + ')';
		};

		function getTriggerMobileMenu() {
			// store trigger that toggle mobile navigation dropdown
			var triggerMobileClass = hidingNav[0].getAttribute('data-mobile-trigger');
			if (!triggerMobileClass) return false;
			if (triggerMobileClass.indexOf('#') == 0) { // get trigger by ID
				var trigger = document.getElementById(triggerMobileClass.replace('#', ''));
				if (trigger) return trigger;
			} else { // get trigger by class name
				var trigger = hidingNav[0].getElementsByClassName(triggerMobileClass);
				if (trigger.length > 0) return trigger[0];
			}

			return false;
		};

		function createPrevElement() {
			// create element to be inserted right before the mainNav to get its top value
			if (mainNav.length < 1) return false;
			var newElement = document.createElement("div");
			newElement.setAttribute('aria-hidden', 'true');
			mainNav[0].parentElement.insertBefore(newElement, mainNav[0]);
			var prevElement = mainNav[0].previousElementSibling;
			prevElement.style.opacity = '0';
			return prevElement;
		};

		function getMainNavTop() {
			if (!prevElement) return;
			mainNavTop = prevElement.getBoundingClientRect().top + window.scrollY;
		};

		function checkNavExpanded() {
			var navIsOpen = false;
			for (var i = 0; i < navOpenArrayClasses.length; i++) {
				if (Util.hasClass(mainNav[0], navOpenArrayClasses[i].trim())) {
					navIsOpen = true;
					break;
				}
			}
			return navIsOpen;
		};

	} else {
		// if window requestAnimationFrame is not supported -> add bg class to fixed header
		var mainNav = document.getElementsByClassName('js-hide-nav--main');
		if (mainNav.length < 1) return;
		if (Util.hasClass(mainNav[0], 'hide-nav--fixed')) Util.addClass(mainNav[0], 'hide-nav--has-bg');
	}
}());
